import { patientNamespace } from "@/store/modules/patient";
import { Patient } from "@/store/modules/patient/types";
import _ from "lodash";
import { Component, Vue } from "vue-property-decorator";
import { Getter } from "vuex-class";

@Component({})
export default class Notes extends Vue {
  @Getter("current", patientNamespace)
  current!: Patient;

  get legendParts() {
    return _.get(this, "current.body.atoms.careNote.legend", "")
      .split("^^")
      .map((t: string) => t.replace(/\\n\\t/g, "<br />"))
      .filter((t: string) => t)
      .map((t: string) => t.split("|").join("<br />"));
  }
}
